<template>
  <div class="pointsDetails">
    <div>
      <module-title title="权益明细">
        <div class="right">
          <el-button type="primary" size="medium" icon="el-icon-arrow-left" @click="$emit('close')">
            返回
          </el-button>
        </div>
      </module-title>
      <div>
        <el-form
          ref="subjectSearchForm"
          :model="searchForm"
          :inline="true"
          label-position="right"
        >
          <el-form-item label="变动依据：" prop="name">
            <el-input
              v-model="searchForm.name"
              name="name"
              maxlength="200"
              placeholder="输入变动依据"
              class="handle-form-input"
              clearable
            />
          </el-form-item>
          <el-form-item label="状态：" prop="expiredFlag">
            <el-select
              v-model="searchForm.expiredFlag"
              name="expiredFlag"
              size="medium"
              class="edit-form-input"
            >
              <el-option key="" label="全部" value="" />
              <el-option
                v-for="item in expiredFlagList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="权益有效期时间段：" prop="dateTime">
            <el-date-picker
              v-model="dateTime"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="起始时间"
              end-placeholder="截至时间"
              :picker-options="datePickerOptions"
              @change="handleChangeDate"
              @blur="dateBlur"
            />
          </el-form-item>
          <el-form-item style="margin-left:50px;">
            <el-button
              type="primary"
              size="medium"
              icon="el-icon-search"
              @click="handleSearchFilter"
            >
              查询
            </el-button>
          </el-form-item>
        </el-form>
        <el-table
          v-loading="listLoading"
          :data="pointsList"
          highlight-current-row
          fit
          element-loading-text="Loading"
          class="list-table"
        >
          <el-table-column type="index" width="55" align="center" label="序号" />
          <el-table-column label="权益内容" align="center" prop="equityName" />
          <el-table-column label="对应物料" prop="equitySpecNo" align="center" />
          <el-table-column label="规格" prop="specUnit" align="center" />
          <el-table-column label="基本单位" prop="specUnitTypeName" align="center" />
          <el-table-column label="权益有效期始" prop="openTime" align="center" />
          <el-table-column label="权益有效期末" prop="expiredTime" align="center" />
          <el-table-column label="状态" prop="expiredFlag" align="center">
            <template slot-scope="scope">
              {{ scope.row.expiredFlag?'已过期':'有效' }}
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :total="searchForm.total"
          :page.sync="searchForm.pageNum"
          :limit.sync="searchForm.pageSize"
          @pagination="pageCurriculumList"
          @handleSizeChange="handleSizeChange"
        />
      </div>
    </div>
  </div>
</template>

<script>

import { getEquityList } from '@/api/userManagement/index/';
export default {
  name: 'PortraitManage',
  props: {
    userProps: {
      default: Object,
      type: Object
    }
  },
  data() {
    return {
      // 搜索表单
      searchForm: {
        productTerminal: '',
        advertisementPosition: '',
        advertisementType: '',
        expiredFlag: '',
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      pointsList: [],
      listLoading: false, // 表格刷新loading
      dateTime: '',
      pickerMinDate: '',
      datePickerOptions: {
        onPick: (obj) => {
          this.pickerMinDate = new Date(obj.minDate).getTime();
        },
        disabledDate: (time) => {
          if (this.pickerMinDate) {
            const day1 = 3 * 30 * 24 * 3600 * 1000;
            const maxTime = this.pickerMinDate + day1;
            const minTime = this.pickerMinDate - day1;
            return time.getTime() > maxTime || time.getTime() < minTime;
          }
        }
      }
    };
  },
  computed: {
    expiredFlagList() {
      return [
        {
          id: 1,
          name: '无效'
        },
        {
          id: 0,
          name: '有效'
        }
      ];
    }
  },
  mounted() {
    this.fetchPointsList();
  },
  methods: {
    dateBlur() {
      this.pickerMinDate = '';
    },
    // 获取积分明细数据
    fetchPointsList() {
      this.listLoading = true;
      var options = {
        accountId: this.userProps.accountId,
        expiredFlag: this.searchForm.expiredFlag,
        validDateEnd: this.searchForm.validDateEnd,
        validDateStart: this.searchForm.validDateStart,
        pageNum: this.searchForm.pageNum,
        pageSize: this.searchForm.pageSize
      };
      getEquityList(options).then((res) => {
        if (res.data && res.data.list && res.data.list.length) {
          this.pointsList = res.data.list;
          this.searchForm.total = res.data.total;
        } else {
          this.pointsList = [];
          this.searchForm.total = 0;
        }
        this.listLoading = false;
      }).catch((err) => {
        console.log(err);
        this.pointsList = [];
        this.total = 0;
        this.listLoading = false;
      });
    },
    handleChangeDate(val) {
      if (val && val.length > 0) {
        this.searchForm.validDateStart = val[0];
        this.searchForm.validDateEnd = val[1];
        this.fetchPointsList();
      } else {
        this.searchForm.validDateStart = '';
        this.searchForm.validDateEnd = '';
      }
      this.dateBlur();
    },
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.fetchPointsList();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.fetchPointsList();
    },
    // 条件查询
    handleSearchFilter() {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = 10;
      this.fetchPointsList();
    }
  }
};
</script>
<style lang="scss" scoped>
.pointsDetails {
  padding-bottom: 20px;
}
.edit-form-input {
  width: 150px;
}
</style>
